import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { graphql } from "gatsby"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Row from "../components/themableUI/row"
import Col from "../components/themableUI/col"

const BlogPage = ({ data }) => (
  <Layout>
    <SEO title="Blog" />
    <div>
      <h2 style={{ display: "none" }}>Blog</h2>
      {data.allMarkdownRemark.edges.map(post => {
        const featImage = getImage(post.node.frontmatter.featuredImage)
        const imgNode = featImage ? (
          <GatsbyImage image={featImage} alt="" />
        ) : (
          <></>
        )
        return (
          <div key={post.node.id}>
            <Row>
              <Col style={{ paddingLeft: "0rem" }} size={6} sizes={{ sm: 6 }}>
                <div>{imgNode}</div>
              </Col>
              <Col size={6} sizes={{ sm: 6 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <small style={{ marginBottom: "0.5rem" }}>
                    {post.node.frontmatter.date}
                  </small>

                  <h3>{post.node.frontmatter.title}</h3>

                  <p>{post.node.excerpt}</p>
                  <Link to={post.node.frontmatter.path}>Read More</Link>
                  <hr />
                </div>
              </Col>
            </Row>
          </div>
        )
      })}
    </div>
  </Layout>
)

export const pageQuery = graphql`
  query blogIndexQuery {
    allMarkdownRemark(filter: { frontmatter: { type: { eq: "blog" } } }) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            path
            date
            type
            featuredImage {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
  }
`

export default BlogPage
